// if we want preload remotes
// import { loadRemoteEntry } from '@angular-architects/module-federation';
// import { environment } from './environments/environment';
// Promise.all([
//   loadRemoteEntry({type: 'module', remoteEntry: environment.remotes.nutrition})
// ])
// .catch(err => console.error('Error loading remote entries', err))
// .then(() => import('./bootstrap'))
// .catch((err) => console.error(err));

// Suppress NG0912 component ID collision warnings in Module Federation
const originalWarn = console.warn;
console.warn = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('NG0912')) {
    return; // Skip NG0912 warnings
  }
  return originalWarn.apply(console, args);
};
// without preloading
import('./bootstrap').catch((err) => console.error(err));
